import { jsx as r } from "react/jsx-runtime";
import { LabelBase as e } from "./LabelBase/LabelBase.js";
const t = (o) => /* @__PURE__ */ r(e, { ...o });
export {
  t as IressLabel
};
